import { render, staticRenderFns } from "./SavingZoneMenuItem.vue?vue&type=template&id=6fa5d495&scoped=true"
import script from "./SavingZoneMenuItem.vue?vue&type=script&lang=js"
export * from "./SavingZoneMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5d495",
  null
  
)

export default component.exports